import api from './api';

export const getIssues = (params) =>
  api.post('/api/admin/getissues', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get issues error:', error);
      throw error;
    });

export const getIssueById = (issueId) =>
  api.post('/api/admin/getissue', { issueId })
    .then(r => r.data)
    .catch(error => {
      console.error('Get issue error:', error);
      throw error;
    });

export const createIssue = (issueData) =>
  api.post('/api/admin/createissue', issueData)
    .then(r => r.data)
    .catch(error => {
      console.error('Create issue error:', error);
      throw error;
    });

export const updateIssue = (issueId, updates) =>
  api.post('/api/admin/updateissue', { issueId, ...updates })
    .then(r => r.data)
    .catch(error => {
      console.error('Update issue error:', error);
      throw error;
    });

export const resolveIssue = (issueId, resolution) =>
  api.post('/api/admin/resolveissue', { issueId, resolution })
    .then(r => r.data)
    .catch(error => {
      console.error('Resolve issue error:', error);
      throw error;
    });

export const getDriverPenalties = (queryParams) => {
  const {
    filter,
    search,
    page = 1,
    limit = 10,
    sort,
    jobType,
    penalty,
    dateLowerRange,
    dateUpperRange,
    scheduledDateLowerRange,
    scheduledDateUpperRange,
  } = queryParams;

  // Build query string with optional parameters
  const params = new URLSearchParams({
    page,
    limit,
    ...(filter && { filter }),
    ...(sort && { sort }),
    ...(search && { search }),
    ...(jobType && { jobType }),
    ...(penalty && { penalty }),
    ...(dateLowerRange && { dateLowerRange }),
    ...(dateUpperRange && { dateUpperRange }),
    ...(scheduledDateLowerRange && { scheduledDateLowerRange }),
    ...(scheduledDateUpperRange && { scheduledDateUpperRange }),
  });

  return api.get(`/api/admin/issuesAndResolutions/driverPenalties?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Get driver penalties error:', error);
      throw error;
    });
};

export const getDriverPayEligibility = (queryParams) => {
  const {
    filter,
    search,
    page = 1,
    limit = 10,
    sort,
    jobType,
    eligibility,
    dateLowerRange,
    dateUpperRange,
    scheduledDateLowerRange,
    scheduledDateUpperRange,
  } = queryParams;

  const params = new URLSearchParams({
    page,
    limit,
    ...(filter && { filter }),
    ...(sort && { sort }),
    ...(search && { search }),
    ...(jobType && { jobType }),
    ...(eligibility && { eligibility }),
    ...(dateLowerRange && { dateLowerRange }),
    ...(dateUpperRange && { dateUpperRange }),
    ...(scheduledDateLowerRange && { scheduledDateLowerRange }),
    ...(scheduledDateUpperRange && { scheduledDateUpperRange }),
  });

  return api.get(`/api/admin/issuesAndResolutions/driverPay?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Get driver pay eligibility error:', error);
      throw error;
    });
};

export const getFlaggedImages = (queryParams) =>
  api.post('/api/admin/issuesAndResolutions/flaggedImages', queryParams)
    .then(r => r.data)
    .catch(error => {
      console.error('Get flagged images error:', error);
      throw error;
    });

export const getFlaggedMessages = (queryParams) =>
  api.post('/api/admin/issuesAndResolutions/flaggedMessages', queryParams)
    .then(r => r.data)
    .catch(error => {
      console.error('Get flagged messages error:', error);
      throw error;
    });

export const getretrieveRefundIssueResolutions = (queryParams) => {
  const {
    filter,
    search,
    page = 1,
    limit = 10,
    sort,
    jobType,
    refund,
    dateLowerRange,
    dateUpperRange,
  } = queryParams;

  const params = new URLSearchParams({
    page,
    limit,
    ...(filter && { filter }),
    ...(sort && { sort }),
    ...(search && { search }),
    ...(jobType && { jobType }),
    ...(refund && { refund }),
    ...(dateLowerRange && { dateLowerRange }),
    ...(dateUpperRange && { dateUpperRange }),
  });

  return api.get(`/api/admin/issuesAndResolutions/refunds?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Get refund issue resolutions error:', error);
      throw error;
    });
};

export const getretrieveDriverPayIssueResolutions = (queryParams) => {
  const {
    filter,
    search,
    page = 1,
    limit = 10,
    sort,
    jobType,
    eligibility,
    dateLowerRange,
    dateUpperRange,
    scheduledDateLowerRange,
    scheduledDateUpperRange,
  } = queryParams;

  const params = new URLSearchParams({
    page,
    limit,
    ...(filter && { filter }),
    ...(sort && { sort }),
    ...(search && { search }),
    ...(jobType && { jobType }),
    ...(eligibility && { eligibility }),
    ...(dateLowerRange && { dateLowerRange }),
    ...(dateUpperRange && { dateUpperRange }),
    ...(scheduledDateLowerRange && { scheduledDateLowerRange }),
    ...(scheduledDateUpperRange && { scheduledDateUpperRange }),
  });

  return api.get(`/api/admin/issuesAndResolutions/driverPay?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Get driver pay issue resolutions error:', error);
      throw error;
    });
};

export const driverCancellationPenalty = (payload) =>
  api.post('/api/admin/issuesAndResolutions/drivercancellationpenalty', payload)
    .then(r => r.data)
    .catch(error => {
      console.error('Driver cancellation penalty error:', error);
      throw error;
    });

export const refundPaymentDecision = (payload) =>
  api.post('/api/admin/issuesAndResolutions/refundpaymentdecision', payload)
    .then(r => r.data)
    .catch(error => {
      console.error('Refund payment decision error:', error);
      throw error;
    });

export const driverPaymentDecision = (payload) =>
  api.post('/api/admin/driverPaymentDecision', payload)
    .then(r => r.data)
    .catch(error => {
      console.error('Driver payment decision error:', error);
      throw error;
    });

// Correct endpoint for driver cancellation penalty decision
export const driverCancellationPenaltyDecision = (payload) =>
  api.post('/api/admin/driverCancellationPenaltyDecision', payload)
    .then(r => r.data)
    .catch(error => {
      console.error('Driver cancellation penalty decision error:', error);
      throw error;
    });

export const addJobNotes = (payload) =>
  api.post('/api/admin/addNote', payload)
    .then(r => r.data)
    .catch(error => {
      console.error('Add job notes error:', error);
      throw error;
    });

export const getJobNotes = (queryParams) => {
  const { id, noteType } = queryParams;
  const url = `/api/admin/notes?id=${id}&noteType=${noteType}`;
  return api.get(url)
    .then(r => r.data)
    .catch(error => {
      console.error('Get job notes error:', error);
      throw error;
    });
};

export const getIssueResolutionsCount = (queryParams) => {
  const params = new URLSearchParams(queryParams).toString();
  const url = `/api/admin/issuesAndResolutionsCounts?${params}`;
  return api.get(url)
    .then(r => r.data)
    .catch(error => {
      console.error('Get issue resolutions count error:', error);
      throw error;
    });
};

export const getretrieveDriverPenaltiesIssueResolutions = (queryParams) => {
  const {
    filter,
    search,
    page = 1,
    limit = 10,
    sort,
    jobType,
    penalty,
    dateLowerRange,
    dateUpperRange,
    scheduledDateLowerRange,
    scheduledDateUpperRange,
  } = queryParams;

  const params = new URLSearchParams({
    page,
    limit,
    ...(filter && { filter }),
    ...(sort && { sort }),
    ...(search && { search }),
    ...(jobType && { jobType }),
    ...(penalty && { penalty }),
    ...(dateLowerRange && { dateLowerRange }),
    ...(dateUpperRange && { dateUpperRange }),
    ...(scheduledDateLowerRange && { scheduledDateLowerRange }),
    ...(scheduledDateUpperRange && { scheduledDateUpperRange }),
  });

  return api.get(`/api/admin/issuesAndResolutions/driverPenalties?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Get retrieve driver penalties issue resolutions error:', error);
      throw error;
    });
};
